import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject, createRef } from 'intact-vue';
import template from './index.vdt';
import { bind } from '../utils';
import { BUTTON_GROUP } from './constants';
import { useConfigContext } from '../config';
export * from './group';
var typeDefs = {
  type: ['default', 'primary', 'warning', 'danger', 'success', 'none', 'secondary', 'link', 'flat'],
  size: ['large', 'default', 'small', 'mini'],
  icon: Boolean,
  circle: Boolean,
  loading: Boolean,
  disabled: Boolean,
  fluid: Boolean,
  htmlType: String,
  tagName: [String, Function],
  value: null,
  name: String,
  tabindex: [String, Number],
  ghost: Boolean
};
var defaults = function defaults() {
  return {
    type: 'default',
    size: 'default',
    htmlType: 'button',
    tagName: 'button',
    tabindex: '0'
  };
};
export var Button = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Button, _Component);
  function Button() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.buttonGroup = inject(BUTTON_GROUP, null);
    _this.elementRef = createRef();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Button.prototype;
  _proto.showLoading = function showLoading() {
    this.set('loading', true);
  };
  _proto.hideLoading = function hideLoading() {
    this.set('loading', false);
  };
  _proto.disable = function disable() {
    this.set('disabled', true);
  };
  _proto.enable = function enable() {
    this.set('disabled', false);
  };
  _proto.isChecked = function isChecked() {
    var group = this.buttonGroup;
    if (!group) return false;
    var _group$get = group.get(),
      checkType = _group$get.checkType,
      groupValue = _group$get.value;
    var _this$get = this.get(),
      value = _this$get.value;
    return value !== undefined ? checkType === 'radio' ? value === groupValue : checkType === 'checkbox' ? Array.isArray(groupValue) && !!~groupValue.indexOf(value) : false : false;
  };
  _proto.onClick = function onClick(e) {
    if (this.get('disabled') || this.get('loading')) {
      e.preventDefault();
      return;
    }
    var buttonGroup = this.buttonGroup;
    if (buttonGroup) {
      var value = this.get('value');
      if (value !== undefined) {
        buttonGroup.setValue(value);
      }
    }
    e.$component = this;
    this.trigger('click', e);
  };
  _proto.onMouseUp = function onMouseUp(e) {
    // when click, blur it to remove the focus style
    this.elementRef.value.blur();
    this.trigger('mouseup', e);
  };
  return Button;
}(Component);
Button.template = template;
Button.typeDefs = typeDefs;
Button.defaults = defaults;
__decorate([bind], Button.prototype, "onClick", null);
__decorate([bind], Button.prototype, "onMouseUp", null);